import { StoryCallHistoryPrimary } from 'src/components/ui/CallHistory/stories/CallHistory.stories';
import ReasonView from '../ReasonView';

export default {
	title: 'Components/ReasonView',
	component: ReasonView,
	parameters: {},
	tags: ['autodocs'],
	args: {},
};

export const StoryReasonViewPrimary = {
	name: 'Primary',
	args: {
		label: 'Звонок',
		date: '29.06.2023 09:03',
		from: 'Леви Томас',
		to: 'Говнова Ольга (Директор)',
	},
};

export const StoryReasonViewCall = {
	name: 'Call',
	args: {
		date: '29.06.2023 09:03',
		from: 'Леви Томас',
		to: 'Говнова Ольга (Директор)',
		call: {
			player: StoryCallHistoryPrimary.args.player,
			duration: '18:09',
			details: StoryCallHistoryPrimary.args.details,
			links: StoryCallHistoryPrimary.args.links,
		},
	},
};
